import React from "react";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";

const DashboardForm = ({
  selectedUser,
  setSelectedUser,
  selectedDescription,
  setSelectedDescription,
  selectedDays,
  setSelectedDays,
}) => {
  const handleSelectUserChange = (e) => {
    setSelectedUser(parseInt(e.target.value, 10));
  };
  const handleSelectDescriptionChange = (e) => {
    setSelectedDescription(e.target.value);
  };

  const handleSelectDayChange = (e) => {
    setSelectedDays(parseInt(e.target.value), 10);
  };

  return (
    <>
      <div className="outer">
        <div>
          <Form.Select value={selectedUser} onChange={handleSelectUserChange}>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </Form.Select>
        </div>
      </div>

      <div className="outer">
        <div>
          <Form.Select
            value={selectedDescription}
            onChange={handleSelectDescriptionChange}
          >
            <option value="passi">passi</option>
            <option value="calcio">calcio</option>
            <option value="corsa">corsa</option>
            <option value="quantita acqqua">quantita acqqua</option>
            <option value="quantità calorie brucciate">quantità calorie brucciate</option>
          </Form.Select>
        </div>
      </div>

      <div className="outer">
        <div>
          <Form.Select value={selectedDays} onChange={handleSelectDayChange}>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
          </Form.Select>
        </div>
      </div>
    </>
  );
};

DashboardForm.propTypes = {
  selectedUser: PropTypes.number,
  selectedDescription: PropTypes.string,
  selectedDays: PropTypes.number,
  setSelectedUser: PropTypes.func,
  setSelectedDescription: PropTypes.func,
  setSelectedDays: PropTypes.func,
};
export default DashboardForm;
